/**
 * Menu favorites SSOT sync helpers.
 * Top bar (FavoritePagesTabs) + MenuGuide + Sidebar dock/stars share user_menu_favorites.
 * hubOverrides.quickPicks mirrors favorites per hub for dock preferences (uncapped).
 */
export const MENU_FAVORITES_CHANGED = 'menu_favorites_changed';

export function emitMenuFavoritesChanged(detail = {}) {
  try {
    window.dispatchEvent(new CustomEvent(MENU_FAVORITES_CHANGED, { detail }));
  } catch {
    /* ignore */
  }
}

/** Find hub id that owns a menu key (or href). */
export function findHubIdForMenuKey(hubs, menuKey) {
  if (!menuKey || !Array.isArray(hubs)) return null;
  for (const hub of hubs) {
    for (const it of hub.items || []) {
      if (it.key === menuKey || it.href === menuKey) return hub.id;
    }
  }
  return null;
}

/**
 * Build per-hub quickPicks from a flat list of favorite menu keys.
 * Keeps existing order within each hub when possible; appends new keys.
 */
export function buildHubQuickPicksFromFavorites(hubs, favoriteKeys, previousOverrides = {}) {
  const favSet = new Set((favoriteKeys || []).filter(Boolean));
  const nextOverrides = { ...(previousOverrides || {}) };

  for (const hub of hubs || []) {
    const hubKeys = (hub.items || []).map((it) => it.key).filter(Boolean);
    const hubKeySet = new Set(hubKeys);
    const prev = nextOverrides[hub.id] && typeof nextOverrides[hub.id] === 'object'
      ? nextOverrides[hub.id]
      : {};
    const prevPicks = Array.isArray(prev.quickPicks) ? prev.quickPicks.filter(Boolean) : [];
    const prevHad = Array.isArray(prev.quickPicks);
    const ordered = [];
    for (const k of prevPicks) {
      if (favSet.has(k) && hubKeySet.has(k) && !ordered.includes(k)) ordered.push(k);
    }
    for (const k of favoriteKeys || []) {
      if (hubKeySet.has(k) && favSet.has(k) && !ordered.includes(k)) ordered.push(k);
    }
    if (!prevHad && ordered.length === 0) continue;
    nextOverrides[hub.id] = {
      ...prev,
      quickPicks: ordered,
    };
  }
  return nextOverrides;
}

/** Normalize API favorites payload → array of menuKey strings (sorted by order). */
export function normalizeFavoriteKeys(favoriteData) {
  if (!Array.isArray(favoriteData)) return [];
  const rows = favoriteData.map((row, index) => {
    if (typeof row === 'string') return { menuKey: row, order: index };
    return {
      menuKey: row.menuKey || row.menu_key || row.key,
      order: typeof row.order === 'number' ? row.order : (row.display_order ?? index),
    };
  }).filter((r) => r.menuKey);
  rows.sort((a, b) => a.order - b.order);
  return rows.map((r) => r.menuKey);
}
